<template>
  <div>
    <label>
      {{ index }}.
      {{ question }}
    </label>
    <table class="table mt-2">
      <p v-if="!responses||responses.length==0" class="text-muted small">
        <i class="material-icons align-middle small">
          error_outline
        </i>
        No answer
      </p>
      <tr v-for="item in responses" :key="item.id">
        <td>
          {{ item.answer_text_1 }}
        </td>
        <td>
          {{ item.answer_text_2 }}
        </td>
      </tr>
    </table>
    <b-link v-if="onModal" class="d-flex text-left pt-2" :href="('/skill-planning/'+getSkillName.id)" >
        Go to the plan to edit your answer
    </b-link>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    responses: Array,
    question: String,
    index: Number,
    id: Number,
    onModal: {
      type:Boolean,
      default:false
    }
  },
  computed: {
    ...mapGetters("planning", [
      "getSkillName",
    ]),
  },
};
</script>
